export const NAME = 'organization_programs'
export const ITEMS_PER_PAGE = 12
